<template>
    <div class="animated fadeIn">
        <div>
            <section class="section-b-space">
                <div>
                    <component-header
                        title="Payment Info"
                        :hasCreate="true"
                        :hasSearch="false"
                        :hasReload="false"
                        :hasback="true"
                        @back-press="$router.push('/myaccount')"
                        createButtonText="Make Payment"
                        @create-press="openMakePayment"
                    />
                    <b-modal
                        v-model="isShowPaymentModel"
                        title="Make Payment"
                        header-class="header-nipige-class"
                        :header-bg-variant="'primary'"
                        :header-text-variant="'light'"
                        size="md"
                        centered
                        hide-footer
                        no-close-on-esc
                        no-close-on-backdrop
                    >
                        <c-input
                            inputType="number"
                            inputId="Amount"
                            lableText="Amount"
                            v-model="amountValue"
                            class="mt-3 ml-1 mr-1 border-style-input"
                        />
                        <div class="text-center mt-3">
                            <button
                                type="button"
                                class="btn btn-primary"
                                classic="mr-1 btn-primary"
                                text="Save"
                                @click="initiatePayment"
                            >
                                Proceed
                            </button>
                        </div>
                    </b-modal>
                    <div class="nipige-v-card-class-top">
                        <div class="text-center mt-3" v-if="isLoading">
                            Loading.............
                        </div>
                        <b-row v-if="!isLoading" class="pl-1 pr-1">
                            <b-col md="3" class="mt-n2">
                                <v-hover v-slot="{ hover }" close-delay="200">
                                    <v-card
                                        height="200"
                                        :elevation="hover ? 10 : 0"
                                        style="
                                            box-shadow: 0px 0px 12px
                                                rgba(0, 0, 0, 0.1);
                                        "
                                        :class="{
                                            'on-hover': hover,
                                            'nipige-v-card-class-top-allowed':
                                                'nipige-v-card-class-top-allowed',
                                        }"
                                    >
                                        <b-row class="pl-2 pt-1">
                                            <b-col>
                                                <h4 class="text-center">
                                                    Allowed Payment
                                                </h4>
                                            </b-col>
                                        </b-row>
                                        <b-row class="mt-3">
                                            <b-col>
                                                <b-row>
                                                    <b-col>
                                                        <h4
                                                            class="my-payment-info-class float-right"
                                                        >
                                                            COD :
                                                        </h4>
                                                    </b-col>
                                                </b-row>
                                                <b-row class="mt-n3">
                                                    <b-col>
                                                        <h4
                                                            class="my-payment-info-class float-right"
                                                        >
                                                            Online :
                                                        </h4>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                            <b-col class="mt-n2">
                                                <b-row>
                                                    <b-col>
                                                        <v-switch
                                                            class="pt-1 mt-2 float-left switch-adjustment-class"
                                                            color="primary"
                                                            inset
                                                            @change="
                                                                updateCodOrOnline
                                                            "
                                                            v-model="codEnable"
                                                        >
                                                        </v-switch>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                    <b-col>
                                                        <v-switch
                                                            class="pt-1 float-left switch-adjustment-class mt-n3"
                                                            color="primary"
                                                            inset
                                                            @change="
                                                                updateCodOrOnline
                                                            "
                                                            v-model="
                                                                onlineEnable
                                                            "
                                                        >
                                                        </v-switch>
                                                    </b-col>
                                                </b-row>
                                            </b-col>
                                        </b-row>
                                    </v-card>
                                </v-hover>
                            </b-col>
                            <b-col class="mt-n3">
                                <b-row>
                                    <v-hover
                                        v-slot="{ hover }"
                                        close-delay="170"
                                    >
                                        <v-card
                                            :elevation="hover ? 10 : 0"
                                            style="
                                                box-shadow: 0px 0px 12px
                                                    rgba(0, 0, 0, 0.1);
                                            "
                                            :class="{
                                                'on-hover': hover,
                                                'nipige-v-card-class-top-allowed mr-2':
                                                    'nipige-v-card-class-top-allowed mr-2',
                                            }"
                                        >
                                            <div
                                                v-if="
                                                    !checkSellerOrOther &&
                                                    onlineEnable
                                                "
                                                class="mt-2"
                                            >
                                                <h4
                                                    class="text-center online-pay-method-class"
                                                >
                                                    Online Payment Details
                                                </h4>
                                            </div>
                                            <b-row
                                                v-if="
                                                    !checkSellerOrOther &&
                                                    onlineEnable
                                                "
                                            >
                                                <b-modal
                                                    title="Update Paytm Details"
                                                    header-class="header-nipige-class"
                                                    id="modal-center"
                                                    ref="modal-paytm"
                                                    size="md"
                                                    centered
                                                    hide-footer
                                                >
                                                    <c-input
                                                        inputType="text"
                                                        inputId="paymentInfo"
                                                        lableText="Enter Paytm Id"
                                                        v-model="paytmId"
                                                        class="mt-3 ml-1 mr-1 border-style-input"
                                                    />
                                                    <c-input
                                                        inputType="text"
                                                        inputId="paymentInfo"
                                                        lableText="Enter Paytm Secret Key"
                                                        v-model="paytmKey"
                                                        class="mt-3 ml-1 mr-1 border-style-input"
                                                    />
                                                    <div
                                                        class="text-center mt-3"
                                                    >
                                                        <button
                                                            type="button"
                                                            class="btn btn-primary"
                                                            classic="mr-1 btn-primary"
                                                            text="Save"
                                                            @click="
                                                                submitPaytmDetails(
                                                                    'paytm',
                                                                )
                                                            "
                                                        >
                                                            Save
                                                        </button>
                                                    </div>
                                                </b-modal>
                                                <b-col>
                                                    <div
                                                        v-if="
                                                            paytmKey == '' ||
                                                            paytmId == ''
                                                        "
                                                        class="text-center mt-4"
                                                    >
                                                        <b-button
                                                            class="main-navigation-button w-1"
                                                            variant="white"
                                                            btn-color="primary1"
                                                            @click="
                                                                editPaytmDetails(
                                                                    'paytm',
                                                                )
                                                            "
                                                        >
                                                            <v-avatar
                                                                class="ml-n2 mt-n1"
                                                                size="35"
                                                            >
                                                                <img
                                                                    src="img/Add.png"
                                                                /> </v-avatar
                                                        ></b-button>
                                                        <h4>Add Paytm</h4>
                                                    </div>
                                                    <v-hover
                                                        v-if="
                                                            paytmKey != '' &&
                                                            paytmId != ''
                                                        "
                                                        v-slot="{ hover }"
                                                        close-delay="170"
                                                    >
                                                        <v-card
                                                            height="160"
                                                            :elevation="
                                                                hover ? 16 : 2
                                                            "
                                                            :class="{
                                                                'on-hover':
                                                                    hover,
                                                                'nipige-v-card-class shadow-none':
                                                                    'nipige-v-card-class shadow-none',
                                                            }"
                                                        >
                                                            <b-row
                                                                class="pl-3 pt-1"
                                                            >
                                                                <b-col md="5">
                                                                    <img
                                                                        class="ml-1"
                                                                        style="
                                                                            height: 60px;
                                                                            width: 80px;
                                                                        "
                                                                        src="img/paytm.jpeg"
                                                                        alt=""
                                                                    />
                                                                </b-col>
                                                                <b-col md="7">
                                                                    <div
                                                                        class="float-right mt-2 mr-3"
                                                                    >
                                                                        <b-button
                                                                            class="main-navigation-button w-1"
                                                                            variant="white"
                                                                            btn-color="primary1"
                                                                            @click="
                                                                                editPaytmDetails(
                                                                                    'paytm',
                                                                                )
                                                                            "
                                                                        >
                                                                            <v-avatar
                                                                                class="ml-n2 mt-n1"
                                                                                size="35"
                                                                            >
                                                                                <img
                                                                                    src="img/Edit.png"
                                                                                /> </v-avatar
                                                                        ></b-button>
                                                                    </div>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row
                                                                class="pl-4 mt-n3"
                                                            >
                                                                <b-col>
                                                                    <h4>
                                                                        Id :
                                                                        <strong
                                                                            class="ac-details-class"
                                                                        >
                                                                            {{
                                                                                paytmId.length >
                                                                                30
                                                                                    ? paytmId.slice(
                                                                                          0,
                                                                                          25,
                                                                                      ) +
                                                                                      "......"
                                                                                    : paytmId
                                                                            }}</strong
                                                                        >
                                                                    </h4>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row
                                                                class="pl-4 mt-n4"
                                                            >
                                                                <b-col>
                                                                    <h4>
                                                                        Key :
                                                                        <strong
                                                                            class="ac-details-class"
                                                                        >
                                                                            {{
                                                                                paytmKey.length >
                                                                                30
                                                                                    ? paytmKey.slice(
                                                                                          0,
                                                                                          25,
                                                                                      ) +
                                                                                      "......"
                                                                                    : paytmKey
                                                                            }}
                                                                        </strong>
                                                                    </h4>
                                                                </b-col>
                                                            </b-row>
                                                        </v-card>
                                                    </v-hover>
                                                </b-col>
                                                <!-- /////////////////////////// -->
                                                <b-col>
                                                    <b-modal
                                                        title="Update Cashfree Details"
                                                        header-class="header-nipige-class"
                                                        id="modal-center"
                                                        ref="modal-cashfree"
                                                        size="md"
                                                        centered
                                                        hide-footer
                                                    >
                                                        <c-input
                                                            inputType="text"
                                                            inputId="paymentInfo"
                                                            lableText="Enter Cashfree Id"
                                                            v-model="cashfreeId"
                                                            class="mt-3 ml-1 mr-1 border-style-input"
                                                        />
                                                        <c-input
                                                            inputType="text"
                                                            inputId="paymentInfo"
                                                            lableText="Enter Cashfree Secret Key"
                                                            v-model="
                                                                cashfreeKey
                                                            "
                                                            class="mt-3 ml-1 mr-1 border-style-input"
                                                        />
                                                        <div
                                                            class="text-center mt-3"
                                                        >
                                                            <button
                                                                type="button"
                                                                class="btn btn-primary"
                                                                classic="mr-1 btn-primary"
                                                                text="Save"
                                                                @click="
                                                                    submitPaytmDetails(
                                                                        'cashfree',
                                                                    )
                                                                "
                                                            >
                                                                Save
                                                            </button>
                                                        </div>
                                                    </b-modal>
                                                    <div
                                                        v-if="
                                                            cashfreeKey == '' ||
                                                            cashfreeId == ''
                                                        "
                                                        class="text-center mt-4"
                                                    >
                                                        <b-button
                                                            class="main-navigation-button w-1"
                                                            variant="white"
                                                            btn-color="primary1"
                                                            @click="
                                                                editPaytmDetails(
                                                                    'cashfree',
                                                                )
                                                            "
                                                        >
                                                            <v-avatar
                                                                class="ml-n2 mt-n1"
                                                                size="35"
                                                            >
                                                                <img
                                                                    src="img/Add.png"
                                                                /> </v-avatar
                                                        ></b-button>
                                                        <h4>Add Cashfree</h4>
                                                    </div>
                                                    <v-hover
                                                        v-if="
                                                            cashfreeKey != '' &&
                                                            cashfreeId != ''
                                                        "
                                                        v-slot="{ hover }"
                                                        close-delay="170"
                                                    >
                                                        <v-card
                                                            height="160"
                                                            :elevation="
                                                                hover ? 10 : 0
                                                            "
                                                            :class="{
                                                                'on-hover':
                                                                    hover,
                                                                'nipige-v-card-class shadow-none':
                                                                    'nipige-v-card-class shadow-none',
                                                            }"
                                                        >
                                                            <b-row
                                                                class="pl-4 pt-1"
                                                            >
                                                                <b-col md="5">
                                                                    <img
                                                                        class="ml-1"
                                                                        style="
                                                                            height: 60px;
                                                                            width: 80px;
                                                                        "
                                                                        src="img/cashfree.jpg"
                                                                        alt=""
                                                                    />
                                                                </b-col>
                                                                <b-col md="7">
                                                                    <div
                                                                        class="float-right mt-2 mr-5"
                                                                    >
                                                                        <b-button
                                                                            class="main-navigation-button w-1"
                                                                            variant="white"
                                                                            btn-color="primary1"
                                                                            @click="
                                                                                editPaytmDetails(
                                                                                    'cashfree',
                                                                                )
                                                                            "
                                                                        >
                                                                            <v-avatar
                                                                                class="ml-n2 mt-n1"
                                                                                size="35"
                                                                            >
                                                                                <img
                                                                                    src="img/Edit.png"
                                                                                /> </v-avatar
                                                                        ></b-button>
                                                                    </div>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row
                                                                class="pl-4 mt-n3"
                                                            >
                                                                <b-col>
                                                                    <h4>
                                                                        Id :
                                                                        <strong
                                                                            class="ac-details-class"
                                                                        >
                                                                            {{
                                                                                cashfreeId.length >
                                                                                30
                                                                                    ? cashfreeId.slice(
                                                                                          0,
                                                                                          25,
                                                                                      ) +
                                                                                      "......"
                                                                                    : cashfreeId
                                                                            }}</strong
                                                                        >
                                                                    </h4>
                                                                </b-col>
                                                            </b-row>
                                                            <b-row
                                                                class="pl-4 mt-n4"
                                                            >
                                                                <b-col>
                                                                    <h4>
                                                                        Key :
                                                                        <strong
                                                                            class="ac-details-class"
                                                                        >
                                                                            {{
                                                                                cashfreeKey.length >
                                                                                30
                                                                                    ? cashfreeKey.slice(
                                                                                          0,
                                                                                          25,
                                                                                      ) +
                                                                                      "......"
                                                                                    : cashfreeKey
                                                                            }}</strong
                                                                        >
                                                                    </h4>
                                                                </b-col>
                                                            </b-row>
                                                        </v-card>
                                                    </v-hover>
                                                </b-col>
                                            </b-row>
                                            <!-- ////////// for seller ////////////// -->
                                            <b-row
                                                v-if="
                                                    checkSellerOrOther &&
                                                    onlineEnable
                                                "
                                            >
                                                <b-container fluid>
                                                    <b-row class="pl-3 pt-1">
                                                        <b-col
                                                            cols="12"
                                                            md="4"
                                                            class="text-center"
                                                        >
                                                            <h4
                                                                class="online-pay-method-class text-center"
                                                            >
                                                                Online Payment
                                                                Details
                                                            </h4>
                                                        </b-col>
                                                        <b-col
                                                            cols="12"
                                                            md="4"
                                                        ></b-col>
                                                        <b-col
                                                            cols="12"
                                                            md="4"
                                                            class="text-center text-md-right"
                                                        >
                                                            <b-button
                                                                class="main-navigation-button w-1"
                                                                variant="white"
                                                                btn-color="primary1"
                                                                @click="
                                                                    editPaytmDetails(
                                                                        'account',
                                                                    )
                                                                "
                                                            >
                                                                <v-avatar
                                                                    class="ml-n2 mt-n1"
                                                                    size="35"
                                                                >
                                                                    <img
                                                                        src="img/Edit.png"
                                                                    />
                                                                </v-avatar>
                                                            </b-button>
                                                        </b-col>
                                                    </b-row>

                                                    <b-row class="mt-3">
                                                        <b-col
                                                            cols="12"
                                                            md="4"
                                                            class="mb-3"
                                                        >
                                                            <h5>
                                                                Acc Holder Name:
                                                                <strong
                                                                    class="ac-details-class"
                                                                    >{{
                                                                        sellerPayementDetails.accHolderName
                                                                    }}</strong
                                                                >
                                                            </h5>
                                                            <h5>
                                                                IFSC Code:
                                                                <strong
                                                                    class="ac-details-class"
                                                                    >{{
                                                                        sellerPayementDetails.ifscCode
                                                                    }}</strong
                                                                >
                                                            </h5>
                                                        </b-col>
                                                        <b-col
                                                            cols="12"
                                                            md="4"
                                                            class="mb-3"
                                                        >
                                                            <h5>
                                                                Bank Name:
                                                                <strong
                                                                    class="ac-details-class"
                                                                    >{{
                                                                        sellerPayementDetails.bankName
                                                                    }}</strong
                                                                >
                                                            </h5>
                                                            <h5>
                                                                Account Number:
                                                                <strong
                                                                    class="ac-details-class"
                                                                    >{{
                                                                        sellerPayementDetails.accNo
                                                                    }}</strong
                                                                >
                                                            </h5>
                                                        </b-col>
                                                        <b-col
                                                            cols="12"
                                                            md="4"
                                                            class="mb-3"
                                                        >
                                                            <h5>
                                                                Email:
                                                                <strong
                                                                    class="ac-details-class"
                                                                    >{{
                                                                        sellerPayementDetails.email
                                                                    }}</strong
                                                                >
                                                            </h5>
                                                            <h5>
                                                                Phone Number:
                                                                <strong
                                                                    class="ac-details-class"
                                                                    >{{
                                                                        sellerPayementDetails.phone
                                                                    }}</strong
                                                                >
                                                            </h5>
                                                        </b-col>
                                                    </b-row>

                                                    <b-row class="mt-2">
                                                        <b-col
                                                            cols="12"
                                                            class="vendor-class text-center text-md-left"
                                                        >
                                                            <h6>
                                                                {{
                                                                    sellerPayementDetails.vendorMode
                                                                }}
                                                                Vendor Id :
                                                                <strong
                                                                    class="ac-details-class-vendor"
                                                                >
                                                                    {{
                                                                        sellerPayementDetails
                                                                            .venderId
                                                                            .length >
                                                                        10
                                                                            ? sellerPayementDetails.venderId.slice(
                                                                                  0,
                                                                                  10,
                                                                              ) +
                                                                              "...."
                                                                            : sellerPayementDetails.venderId
                                                                    }}
                                                                </strong>
                                                            </h6>
                                                        </b-col>
                                                    </b-row>
                                                    <b-modal
                                                        title="Update Bank Details"
                                                        header-class="header-nipige-class"
                                                        id="modal-center"
                                                        ref="modal-account"
                                                        size="md"
                                                        centered
                                                        hide-footer
                                                    >
                                                        <c-input
                                                            inputType="text"
                                                            lableText="Enter Account Holder Name"
                                                            v-model="
                                                                sellerPayementDetails.accHolderName
                                                            "
                                                            class="mt-3 border-style-input"
                                                        />
                                                        <c-input
                                                            inputType="text"
                                                            lableText="Enter IFSC Code"
                                                            v-model="
                                                                sellerPayementDetails.ifscCode
                                                            "
                                                            class="mt-3 border-style-input"
                                                        />
                                                        <c-input
                                                            inputType="text"
                                                            lableText="Enter Bank Name"
                                                            v-model="
                                                                sellerPayementDetails.bankName
                                                            "
                                                            class="mt-3 border-style-input"
                                                        />
                                                        <c-input
                                                            inputType="number"
                                                            lableText="Enter Account No"
                                                            v-model="
                                                                sellerPayementDetails.accNo
                                                            "
                                                            class="mt-3 border-style-input"
                                                        />
                                                        <c-input
                                                            inputType="text"
                                                            lableText="Enter Your Email"
                                                            v-model="
                                                                sellerPayementDetails.email
                                                            "
                                                            class="mt-3 border-style-input"
                                                        />
                                                        <c-input
                                                            inputType="number"
                                                            lableText="Enter Your Phone No"
                                                            v-model="
                                                                sellerPayementDetails.phone
                                                            "
                                                            class="mt-3 border-style-input"
                                                        />
                                                        <eb-select
                                                            type="select"
                                                            v-model="
                                                                sellerPayementDetails.vendorModeOptionSelect
                                                            "
                                                            :options="
                                                                vendorModeOptions
                                                            "
                                                            label="label"
                                                            :id="'selecttime'"
                                                            :placeholder="'Select Vendor Mode'"
                                                            :selected="
                                                                sellerPayementDetails.vendorModeOptionSelect
                                                            "
                                                            class="ml-1 mr-1 mt-2"
                                                        ></eb-select>
                                                        <c-input
                                                            inputType="text"
                                                            lableText="Enter Vendor Id"
                                                            v-model="
                                                                sellerPayementDetails.venderId
                                                            "
                                                            class="mt-3 border-style-input"
                                                        />
                                                        <div
                                                            class="text-center mt-3"
                                                        >
                                                            <button
                                                                type="button"
                                                                class="btn btn-primary"
                                                                @click="
                                                                    submitSellerPayment()
                                                                "
                                                            >
                                                                Save
                                                            </button>
                                                        </div>
                                                    </b-modal>
                                                </b-container>
                                            </b-row>
                                        </v-card>
                                    </v-hover>
                                </b-row>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </section>
            <section class="mt-3">
                <component-header
                    title="Transaction History"
                    @search-query="(val) => (filter = val)"
                    :isLoading="loading"
                    @reload-data="getTransactionHistory"
                    :hasCreate="false"
                    :hasback="false"
                />
                <b-card class="card-wrap" border-variant="info">
                    <b-row>
                        <b-col md="3" class="my-1">
                            <b-form-group label-cols-sm="3" class="mb-0">
                                <eb-select
                                    type="select"
                                    v-model="selectedPeriod"
                                    :options="periodList"
                                    label="text"
                                    :id="'selecttime'"
                                    :selected="selectedPeriod"
                                    @input="changePeriod"
                                ></eb-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <div>
                        <b-table
                            :fields="Columns"
                            :items="transactionList"
                            :dark="false"
                            :filter="filter"
                            :hover="true"
                            thead-class="header"
                            :striped="false"
                            :bordered="true"
                            :current-page="currentPage"
                            :per-page="perPage"
                            :small="false"
                            show-empty
                            :fixed="false"
                        >
                            <template slot="cell(createdAt)" slot-scope="data">
                                <div>
                                    {{ data.item.createdAt | formatedate }}
                                </div>
                            </template>
                            <template
                                slot="paymentResponse.paymentMode"
                                slot-scope="data"
                            >
                                <div>
                                    {{
                                        data.item.paymentResponse.paymentMode
                                            | formatMode
                                    }}
                                </div>
                            </template>
                            <template slot="cell(empty)">
                                <div v-if="loading" class="text-center">
                                    <span><b>Loading...</b></span>
                                </div>
                                <div v-else class="text-center">
                                    No data available.
                                </div>
                            </template>
                        </b-table>
                    </div>
                    <div style="float: right">
                        <b-pagination
                            v-model="currentPage"
                            :per-page="perPage"
                            :total-rows="transactionList.length"
                            aria-controls="my-table"
                            prev-text="Prev"
                            next-text="Next"
                        ></b-pagination>
                    </div>
                </b-card>
            </section>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ComponentHeader from "@/components/componentNewHeader";
import { PAYTM_BASEURL } from "@/services/index";
import moment from "moment";

export default {
    components: {
        loader,
        cInput,
        ebSelect,
        ComponentHeader,
    },
    data() {
        return {
            isLoading: false,
            checkSellerOrOther: false,
            partnerAllData: "",
            paytmId: "",
            paytmKey: "",
            cashfreeId: "",
            cashfreeKey: "",
            codEnable: false,
            onlineEnable: false,
            loading: false,
            paymentInfo: "",
            isShowPaymentModel: false,
            amountValue: null,
            currentPage: 1,
            filter: "",
            perPage: 10,
            sellerPayementDetails: {
                accHolderName: "",
                ifscCode: "",
                bankName: "",
                accNo: "",
                email: "",
                phone: "",
                vendorModeOptionSelect: "",
                vendorMode: "",
                venderId: "",
            },
            vendorModeOptions: [
                {
                    label: "Paytm",
                    value: "PAYTM",
                },
                {
                    label: "Cashfree",
                    value: "CASHFREE",
                },
            ],
            Columns: [
                {
                    key: "order",
                    label: "ID",
                },
                {
                    key: "paymentService",
                    label: "Payment Service",
                },
                {
                    key: "paymentResponse.txnAmount",
                    label: "Amount",
                    sortable: true,
                },
                {
                    key: "paymentResponse.bankName",
                    label: "Bank Name",
                    sortable: true,
                },
                {
                    key: "paymentResponse.bankTxnId",
                    label: "Bank Ref#",
                    sortable: true,
                },
                {
                    key: "paymentResponse.paymentMode",
                    label: "Payment Mode",
                    sortable: true,
                },

                {
                    key: "paymentStatus",
                    label: "Payment Status",
                },
                {
                    key: "createdAt",
                    label: "Date",
                    sortable: true,
                },
            ],
            selectedPeriod: {
                text: "Last 7 days",
                value: 7,
            },
            periodList: [
                {
                    text: "Last 7 days",
                    value: 7,
                },
                {
                    text: "Last 15 days",
                    value: 15,
                },
                {
                    text: "Last 30 days",
                    value: 30,
                },
                {
                    text: "Last 3 Months",
                    value: 90,
                },
                {
                    text: "Last 6 Months",
                    value: 180,
                },
            ],
        };
    },
    computed: {
        ...mapGetters({
            getPartnerPreferences: "partner/GetPartnerPreferences",
            transactionList: "subscription/GetTransactionsList",
            getPartnerPaymentPreferencesGetter:
                "partner/getPartnerPaymentPreferencesGetter",
            getPartnerPaymentConfig: "partner/GetPartnerPaymentConfig",
            getSellerProviderConfig: "partner/GetSellerProviderConfigGatter",
        }),
        paymentInfoData() {
            try {
                if (
                    this.getPartnerPreferences.paymentConfig &&
                    this.getPartnerPreferences.paymentConfig.UPIID
                ) {
                    return this.getPartnerPreferences.paymentConfig.UPIID;
                } else {
                    return "Not Available";
                }
            } catch (err) {
                return "Not Available";
            }
        },
    },

    methods: {
        ...mapActions({
            updatePreference: "partner/updatePartnerPreferences",
            getPreferenceAction: "partner/getPartnerPreferences",
            getPartnerPaymentPreferencesAction:
                "partner/getPartnerPaymentPreferencesAction",
            getPartnerPaymentConfigAction:
                "partner/getPartnerPaymentConfigAction",
            getSellerProviderConfigAction:
                "partner/getSellerProviderConfigAction",
        }),
        async submitSellerPayment() {
            let payloadAcountDetails = {
                id: this.partnerAllData._id,
                data: {
                    category: this.partnerAllData.category,
                    bank: {
                        name: this.sellerPayementDetails.bankName,
                        accountNo: this.sellerPayementDetails.accNo,
                        ifscCode: this.sellerPayementDetails.ifscCode,
                        accountName: this.sellerPayementDetails.accHolderName,
                        email: this.sellerPayementDetails.email,
                        phone: this.sellerPayementDetails.phone,
                    },
                },
            };

            if (
                this.sellerPayementDetails.vendorModeOptionSelect != "" &&
                this.sellerPayementDetails.vendorModeOptionSelect.value ==
                    "PAYTM"
            ) {
                payloadAcountDetails.data.paytm = {
                    vendorId: this.sellerPayementDetails.venderId,
                };
            }
            if (
                this.sellerPayementDetails.vendorModeOptionSelect != "" &&
                this.sellerPayementDetails.vendorModeOptionSelect.value ==
                    "CASHFREE"
            ) {
                payloadAcountDetails.data.cashfree = {
                    vendorId: this.sellerPayementDetails.venderId,
                };
            }

            await this.$store
                .dispatch(
                    "partner/updatePartnerPaymentConfigAction",
                    payloadAcountDetails,
                )
                .then((result) => {
                    this.$swal({
                        title: "Success",
                        text: "Seller bank details updated successfully!",
                        type: "success",
                    });
                    this.$refs["modal-account"].hide();
                })
                .catch((err) => {
                    this.$swal({
                        title: "Sorry",
                        text: "Could not update seller bank details",
                        type: "error",
                    });
                });
        },
        editPaytmDetails(mode) {
            if (mode == "paytm") {
                this.$refs["modal-paytm"].show();
            } else if (mode == "cashfree") {
                this.$refs["modal-cashfree"].show();
            } else if ((mode = "account")) {
                this.$refs["modal-account"].show();
            }
        },
        async submitPaytmDetails(mode) {
            if (mode == "paytm") {
                let paytmPayload = {
                    category: this.partnerAllData.category,
                    paytm: {
                        appId: this.paytmId,
                        secretKey: this.paytmKey,
                    },
                };

                let paytmPayloadFinal = {
                    id: this.partnerAllData._id,
                    data: paytmPayload,
                };

                await this.$store
                    .dispatch(
                        "tenant/setPaymentConfigAction",
                        paytmPayloadFinal,
                    )
                    .then((res) => {
                        this.$swal({
                            title: "Success",
                            text: "Paytm details updated successfully!",
                            type: "success",
                        });
                        this.$refs["modal-paytm"].hide();
                    })
                    .catch((err) => {
                        this.$swal({
                            title: "Sorry",
                            text: "Unable to update paytm details",
                            type: "error",
                        });
                    });
            } else if (mode == "cashfree") {
                let cashfreePayload = {
                    category: this.partnerAllData.category,
                    cashfree: {
                        appId: this.cashfreeId,
                        secretKey: this.cashfreeKey,
                    },
                };

                let cashfreePayloadFinal = {
                    id: this.partnerAllData._id,
                    data: cashfreePayload,
                };

                await this.$store
                    .dispatch(
                        "tenant/setPaymentConfigAction",
                        cashfreePayloadFinal,
                    )
                    .then((res) => {
                        this.$swal({
                            title: "Success",
                            text: "Cashfree details updated successfully!",
                            type: "success",
                        });
                        this.$refs["modal-cashfree"].hide();
                    })
                    .catch((err) => {
                        this.$swal({
                            title: "Sorry",
                            text: "Unable to update cashfree details",
                            type: "error",
                        });
                    });
            }

            await this.getPartnerPaymentConfigAction(this.partnerAllData._id);
            try {
                if (this.getPartnerPaymentConfig.paytm) {
                    this.paytmId = this.getPartnerPaymentConfig.paytm
                        ? this.getPartnerPaymentConfig.paytm.appId
                        : "";
                    this.paytmKey = this.getPartnerPaymentConfig.paytm
                        ? this.getPartnerPaymentConfig.paytm.secretKey
                        : "";
                }

                if (this.getPartnerPaymentConfig.cashfree) {
                    this.cashfreeId = this.getPartnerPaymentConfig.cashfree
                        ? this.getPartnerPaymentConfig.cashfree.appId
                        : "";
                    this.cashfreeKey = this.getPartnerPaymentConfig.cashfree
                        ? this.getPartnerPaymentConfig.cashfree.secretKey
                        : "";
                }
            } catch {}
        },
        async updateCodOrOnline() {
            let payloadSetConfig = {
                id: this.partnerAllData._id,
                data: {
                    paymentMethod: {
                        cod: this.codEnable,
                        online: this.onlineEnable,
                    },
                },
            };

            await this.$store
                .dispatch(
                    "partner/updatePartnerPaymentPreferencesAction",
                    payloadSetConfig,
                )
                .then(async (result) => {
                    this.$swal({
                        title: "Success",
                        text: "Payment Methods Updated!",
                        type: "success",
                    });

                    await this.getPartnerPaymentPreferencesAction(
                        this.partnerAllData._id,
                    );
                    try {
                        if (
                            this.getPartnerPaymentPreferencesGetter
                                .preferences &&
                            this.getPartnerPaymentPreferencesGetter.preferences
                                .paymentMethod
                        ) {
                            this.onlineEnable =
                                this.getPartnerPaymentPreferencesGetter.preferences.paymentMethod.online;
                            this.codEnable =
                                this.getPartnerPaymentPreferencesGetter.preferences.paymentMethod.cod;
                        }
                    } catch {}
                })
                .catch((err) => {
                    this.$swal({
                        title: "Sorry",
                        text: "Unable to update payment Methods",
                        type: "error",
                    });
                });
        },
        changePeriod(event) {
            this.getTransactionHistory();
        },
        getTransactionHistory() {
            this.loading = true;
            let payload = {
                days: this.selectedPeriod.value,
            };
            this.$store
                .dispatch("subscription/PaymentTransactionList", payload)
                .then((data) => {
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        updatePaymentInfo(item) {
            const data = {
                partner: JSON.parse(sessionStorage.getItem("userLogin"))._id,
                UPIID: item,
            };
            this.updatePreference(data)
                .then((response) => {
                    this.$swal({
                        title: "Success",
                        text: "Payment Info Updated successfully!",
                        type: "success",
                    });
                    this.$refs["modal-center"].hide();
                    this.getPreferenceAction(
                        JSON.parse(sessionStorage.getItem("userLogin"))._id,
                    );
                })
                .catch((error) => {
                    this.$swal({
                        title: "Error",
                        text: "Could not Update Payment Info",
                        type: "error",
                    });
                });
        },
        editPayment() {
            this.paymentInfo = this.paymentInfoData;
            this.$refs["modal-center"].show();
        },
        openMakePayment() {
            this.isShowPaymentModel = true;
        },
        initiatePayment() {
            let dataObj = {
                amount: {
                    value: this.amountValue,
                    currency: "INR",
                },
                user: {
                    mobile: this.$currentUserData
                        ? this.$currentUserData.phone
                        : "",
                    email: this.$currentUserData
                        ? this.$currentUserData.email
                        : "",
                },
                concern: "WALLET",
            };
            this.$store
                .dispatch("subscription/createPaymentRequest", {
                    data: dataObj,
                    method: "PAYTM",
                })
                .then((result) => {
                    if (result.status === 1) {
                        this.initPaytm(result.response);
                    }
                })
                .catch((error) => {
                    //
                });
        },
        initPaytm(paymentData) {
            let recaptchaScript = document.createElement("script");
            recaptchaScript.setAttribute(
                "src",
                `${PAYTM_BASEURL}/merchantpgpui/checkoutjs/merchants/${paymentData.body.mid}.js`,
            );
            document.head.appendChild(recaptchaScript);
            fetch(
                `${PAYTM_BASEURL}/theia/api/v1/initiateTransaction?mid=${paymentData.body.mid}&orderId=${paymentData.body.orderId}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        body: paymentData.body,
                        head: {
                            signature: paymentData.head.signature,
                        },
                    }),
                },
            ).then((response) =>
                response.json().then((json) => {
                    this.isShowPaymentModel = false;
                    this.amountValue = null;
                    var config = {
                        root: "",
                        flow: "DEFAULT",
                        merchant: {
                            redirect: false,
                            name: "Nipige Payments",
                        },
                        data: {
                            orderId:
                                paymentData.body.orderId /* update order id */,
                            token:
                                json.body.resultInfo.resultStatus === "S"
                                    ? json.body.txnToken
                                    : "" /* update token value */,
                            tokenType: "TXN_TOKEN",
                            amount: paymentData.body.txnAmount
                                .value /* update amount */,
                        },
                        handler: {
                            notifyMerchant: (data) => {},
                            transactionStatus: async (data) => {
                                // if transaction is success
                                if (
                                    data.STATUS === "TXN_SUCCESS" &&
                                    data.RESPCODE === "01"
                                ) {
                                    let payload = {};
                                    payload["txData"] = {
                                        orderId: data.ORDERID,
                                        referenceId: data.TXNID,
                                        txStatus: data.STATUS,
                                        txMsg: data.RESPMSG,
                                        txTime: data.TXNDATE,
                                        signature: data.CHECKSUMHASH,
                                        PaymentServiceName: data.GATEWAYNAME,
                                    };
                                    let checkPaytmEle =
                                        document.getElementById(
                                            "paytm-checkoutjs",
                                        );
                                    if (checkPaytmEle) {
                                        checkPaytmEle.style.display = "none";
                                    }
                                    this.$store
                                        .dispatch(
                                            "subscription/verifyPaymentRequest",
                                            {
                                                orderId:
                                                    paymentData.body.orderId,
                                                refresh: false,
                                            },
                                        )
                                        .then(() => {
                                            this.getTransactionHistory();
                                        });
                                    this.$swal({
                                        title: "Success",
                                        text: "Payment Success!",
                                        type: "success",
                                    });
                                }
                                // if status is pending
                                else if (
                                    data.STATUS === "PENDING" ||
                                    data.RESPCODE === "400" ||
                                    data.RESPCODE === "402"
                                ) {
                                    let checkPaytmEle =
                                        document.getElementById(
                                            "paytm-checkoutjs",
                                        );
                                    if (checkPaytmEle) {
                                        checkPaytmEle.style.display = "none";
                                    }
                                    this.$swal({
                                        title: data.STATUS,
                                        text: data.RESPMSG,
                                        type: "warning",
                                    });
                                    this.$store
                                        .dispatch(
                                            "subscription/verifyPaymentRequest",
                                            {
                                                orderId:
                                                    paymentData.body.orderId,
                                                refresh: false,
                                            },
                                        )
                                        .then(() => {
                                            this.getTransactionHistory();
                                        });
                                }

                                // if transaction is failed.
                                else {
                                    let checkPaytmEle =
                                        document.getElementById(
                                            "paytm-checkoutjs",
                                        );
                                    if (checkPaytmEle) {
                                        checkPaytmEle.style.display = "none";
                                    }
                                    this.$store
                                        .dispatch(
                                            "subscription/verifyPaymentRequest",
                                            {
                                                orderId:
                                                    paymentData.body.orderId,
                                                refresh: false,
                                            },
                                        )
                                        .then(() => {
                                            this.getTransactionHistory();
                                        });
                                    this.$swal({
                                        title: data.STATUS,
                                        text: data.RESPMSG,
                                        type: "error",
                                    });
                                }
                            },
                        },
                    };

                    if (window.Paytm && window.Paytm.CheckoutJS) {
                        window.Paytm.CheckoutJS.onLoad(
                            function excecuteAfterCompleteLoad() {
                                // initialze configuration using init method
                                window.Paytm.CheckoutJS.init(config)
                                    .then(function onSuccess() {
                                        // after successfully updating configuration, invoke JS Checkout
                                        window.Paytm.CheckoutJS.invoke();
                                    })
                                    .catch(function onError(error) {
                                        //
                                    });
                            },
                        );
                    }
                }),
            );
        },
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY hh:mm A");
            }
        },
        formatMode: (mode) => {
            if (mode) {
                if (mode === "CC") {
                    return "Credit Card";
                } else if (mode === "DC") {
                    return "Debit Card";
                } else if (mode === "NB") {
                    return "Net banking";
                } else if (mode === "PPI") {
                    return "Paytm Wallet";
                } else {
                    return mode;
                }
            }
        },
    },
    async mounted() {
        this.loading = true;
        this.isLoading = true;
        this.partnerAllData = this.$currentUserData;
        this.getTransactionHistory();
        // this.getPreferenceAction(
        //   JSON.parse(sessionStorage.getItem("userLogin"))._id
        // );

        await this.getPartnerPaymentPreferencesAction(this.partnerAllData._id);
        try {
            if (
                this.getPartnerPaymentPreferencesGetter.preferences &&
                this.getPartnerPaymentPreferencesGetter.preferences
                    .paymentMethod
            ) {
                this.onlineEnable =
                    this.getPartnerPaymentPreferencesGetter.preferences.paymentMethod.online;
                this.codEnable =
                    this.getPartnerPaymentPreferencesGetter.preferences.paymentMethod.cod;
            }
        } catch {}

        if (this.partnerAllData.category == "SELLER") {
            await this.getSellerProviderConfigAction(this.partnerAllData._id);
            try {
                if (this.getSellerProviderConfig.bank) {
                    this.sellerPayementDetails.accHolderName = this
                        .getSellerProviderConfig.bank.accountName
                        ? this.getSellerProviderConfig.bank.accountName
                        : "";
                    this.sellerPayementDetails.ifscCode = this
                        .getSellerProviderConfig.bank.ifscCode
                        ? this.getSellerProviderConfig.bank.ifscCode
                        : "";
                    this.sellerPayementDetails.bankName = this
                        .getSellerProviderConfig.bank.name
                        ? this.getSellerProviderConfig.bank.name
                        : "";
                    this.sellerPayementDetails.accNo = this
                        .getSellerProviderConfig.bank.accountNo
                        ? this.getSellerProviderConfig.bank.accountNo
                        : "";
                    this.sellerPayementDetails.email = this
                        .getSellerProviderConfig.bank.email
                        ? this.getSellerProviderConfig.bank.email
                        : "";
                    this.sellerPayementDetails.phone = this
                        .getSellerProviderConfig.bank.phone
                        ? this.getSellerProviderConfig.bank.phone
                        : "";
                }

                if (this.getSellerProviderConfig.cashfree) {
                    this.sellerPayementDetails.vendorModeOptionSelect = {
                        label: "Cashfree",
                        value: "CASHFREE",
                    };
                    this.sellerPayementDetails.vendorMode = "Cashfree";
                    this.sellerPayementDetails.venderId = this
                        .getSellerProviderConfig.cashfree.vendorId
                        ? this.getSellerProviderConfig.cashfree.vendorId
                        : "Not Available";
                }

                if (this.getSellerProviderConfig.paytm) {
                    this.sellerPayementDetails.vendorModeOptionSelect = {
                        label: "Paytm",
                        value: "PAYTM",
                    };
                    this.sellerPayementDetails.vendorMode = "Paytm";
                    this.sellerPayementDetails.venderId = this
                        .getSellerProviderConfig.paytm.vendorId
                        ? this.getSellerProviderConfig.paytm.vendorId
                        : "Not Available";
                }
            } catch {}
        } else {
            await this.getPartnerPaymentConfigAction(this.partnerAllData._id);
            try {
                if (this.getPartnerPaymentConfig.paytm) {
                    this.paytmId = this.getPartnerPaymentConfig.paytm
                        ? this.getPartnerPaymentConfig.paytm.appId
                        : "";
                    this.paytmKey = this.getPartnerPaymentConfig.paytm
                        ? this.getPartnerPaymentConfig.paytm.secretKey
                        : "";
                }

                if (this.getPartnerPaymentConfig.cashfree) {
                    this.cashfreeId = this.getPartnerPaymentConfig.cashfree
                        ? this.getPartnerPaymentConfig.cashfree.appId
                        : "";
                    this.cashfreeKey = this.getPartnerPaymentConfig.cashfree
                        ? this.getPartnerPaymentConfig.cashfree.secretKey
                        : "";
                }
            } catch {}
        }

        if (this.partnerAllData.category == "SELLER") {
            this.checkSellerOrOther = true;
        } else {
            this.checkSellerOrOther = false;
        }
        this.loading = false;
        this.isLoading = false;
    },
};
</script>
<style>
p {
    font-size: 13px;
}
h4 {
    font-size: 16px;
    color: var(--secondary);
}
.row + .row {
    margin-top: 0px;
}
.modal-content {
    border-radius: 10px 10px 10px 10px;
}
.modal-title {
    color: white;
}
.header-nipige-class {
    background-color: var(--secondary);
    border-radius: 10px 10px 0px 0px;
}
</style>
<style scoped>
h4 {
    font-size: 20px;
    color: var(--secondary);
}

h5 {
    font-size: 18px;
    color: var(--secondary);
}
h6 {
    font-size: 15px;
    color: var(--secondary);
}
.vendor-class {
    margin-top: -5px;
}
.ac-details-class-vendor {
    font-size: 13px;
    color: #000000;
}
.ac-details-class {
    font-size: 15px;
    color: #000000;
}

.my-payment-info-class {
    font-size: 18px;
    color: var(--secondary);
}
.nipige-v-card-class-top-allowed {
    margin-top: 35px;
    height: 800px;
    background: #ffffff;
    /* border: 1px solid #dee3ea; */
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #ffffff;
    border-radius: 10px;
}
.online-pay-method-class {
    margin-top: 15px;
}
.switch-adjustment-class {
    margin-top: -7px;
}

.theme--light.v-input--switch__track {
    background-color: aqua;
}
</style>
